import * as LocalOperations from "@/Common/Operations/operations.local";
import { NotesConfigurationModel } from "@/Patient/Models/NotesConfigurationModel";
import { NotesConfigurationSettings } from "@/Patient/Models/Settings/NotesConfigurationSettings";
import { NotesFilterSettings } from "@/Patient/Models/Settings/NotesFilterSettings";

class MedicalNotesConfigurationHelper {
    /**
     * Get note configuration settings for current patient
    */
    public static getNoteConfigurationSettingsForCurrentPatient(): NotesConfigurationModel {
        let container = cacheStore.UserSettings?.NotesFilterSettings?.NotesConfigurationSettings;

        if (!container) {
            const exludedConsultationsCodes = cacheStore.ClinicSettings.EnableDirectPatientProfileEdits ? ["Summary Update", "Prescription", "PrescriptionRenewal"] : [];
            const defaultConfig = new NotesConfigurationModel();

            defaultConfig.EncounterContexts = cacheStore
                ?.FindLookupsByTypeCode("CONSULTATIONCONTEXT")
                .filter(lookup => !exludedConsultationsCodes.contains(lookup.LookupCode))
                .map(lookup => lookup.LookupID) ?? [];

            container = new NotesConfigurationSettings({ default: defaultConfig });
        }

        const config = container?.[patientStore.getCurrentPatientContactId()] ?? container?.["default"];

        return config ? { ...config } : null;
    }

    /**
     * Get either the specific user or default note configurations settings and update `NotesFilterSettings` if consultationContext exists
    */
    public static getSpecificConfigAndUpdateNotesFilterSettings(): NotesConfigurationModel {
        // get or create config container
        let container = cacheStore.UserSettings?.NotesFilterSettings?.NotesConfigurationSettings;

        if (!container) {
            const defaultConfig = new NotesConfigurationModel();

            const exludedConsultationsCodes = cacheStore.ClinicSettings.EnableDirectPatientProfileEdits ? ["Summary Update", "Prescription", "PrescriptionRenewal"] : [];

            defaultConfig.EncounterContexts = cacheStore
                ?.FindLookupsByTypeCode("CONSULTATIONCONTEXT")
                .filter(lookup => !exludedConsultationsCodes.contains(lookup.LookupCode))
                .map(lookup => lookup.LookupID) ?? [];

            if (defaultConfig.EncounterContexts.any()) {
                const notesFilterSettings = new NotesFilterSettings();
                container = new NotesConfigurationSettings({ default: defaultConfig });
                notesFilterSettings.NotesConfigurationSettings = container;

                sessionStore.dispatch(LocalOperations.Misc.UpdateNotesFilterSettings, {
                    notesFilterSettings
                });
            }
        }

        // get config for patient
        const config = container?.[patientStore.getCurrentPatientContactId()] ?? container?.["default"];

        return config ? { ...config } : null;
    }
}

export { MedicalNotesConfigurationHelper };
